import { api as com, apiFuns } from "sw-hic";
let { get, post, put, del } = apiFuns;
apiFuns.exceptedReqs.push(/\/api\/datacenter\/module\/exec\/.*/i);
const api = {
  Page: apiFuns.genStandard("page", "/api/datacenter", true),
  SiteMap: apiFuns.genStandard("siteMap", "/api/datacenter", true),
  Module: {
    ...apiFuns.genStandard("module", "/api/datacenter", true),
    execSql: (para) => post("/api/datacenter/module/exec", para),
  },
  // StaffRole: apiFuns.genStandard("staffRole", "/api/md"),
  Staff: {
    queryRole: (id, para) => get(`/api/md/staff/${id}/role`, para),
  },
  Log: apiFuns.genStandard("searchLog", "/api/datacenter"),
};

export default api;
